import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { InfoboxService } from '../infobox/infobox.service';

import { MapCityComponent } from './map-city/map-city.component';
import { MapStopsComponent } from './map-stops/map-stops.component';
import { MapVehiclesComponent } from './map-vehicles/map-vehicles.component';
import { MapService } from './map.service';

@Component({
	selector: 'app-map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.css'],
})
export class MapComponent implements OnInit, OnDestroy {
	@ViewChild(MapCityComponent) transportsCityComponent: MapCityComponent;
	@ViewChild(MapStopsComponent) mapStopsComponent: MapStopsComponent;
	@Input() map: Array<any> = [];
	@Output() mapChange = new EventEmitter();
	@Input() data;
	@Output() dataChange = new EventEmitter();
	@Input() showAdditionalCities = false;
	private serviceSubscribtion;

	connections: Array<any> = [];

	constructor(
		protected infobox: InfoboxService,
		public service: MapService,
	) {}

	ngOnInit(): void {
		this.serviceSubscribtion = this.service.changes.subscribe((data) => {
			switch (data.type) {
				case 'selectVehicle':
				case 'transfer':
					setTimeout(() => {
						this.generateConnections();
					});
					break;
			}
		});
	}

	ngOnDestroy(): void {
		if (this.serviceSubscribtion) {
			this.serviceSubscribtion.unsubscribe();
		}
	}

	citySelect(city): void {
		if (!this.service.vehicleSelected) {
			this.infobox.error('Wybierz pojazd');
			return;
		}
		this.service.citySelected = city;
		new MapCityComponent(this.service).open();
	}

	destinationSet(destination): void {
		if (!this.service.havePeople(this.service.vehicleSelected)) {
			this.infobox.error('Nie można wybrać tego przystanku jeśli na pojeździe nie ma klientów');
			return;
		}
		this.service.target(destination, this.service.vehicleSelected);
	}

	stopSet(item): void {
		if (!this.service.havePeople(this.service.vehicleSelected)) {
			this.infobox.error('Nie można wybrać tego przystanku jeśli na pojeździe nie ma klientów');
			return;
		}
		this.service.cruising(null, this.service.vehicleSelected, item);
	}

	stopsManage(type: string): void {
		this.mapStopsComponent.open(type);
	}

	vehiclesToggle(): void {
		new MapVehiclesComponent(this.service).toggle();
	}

	generateMap() {
		this.map = [];
		for (let rowNum = 1; rowNum <= 16; rowNum++) {
			const columns = [];
			for (let colNum = 1; colNum <= 9; colNum++) {
				const city = this.cityFindByPos(colNum, rowNum);
				columns.push(city);
			}
			this.map.push(columns);
		}
	}

	generateConnectionsAll() {
		const transports = this.service.transports.filter(
			(value, index, self) => index === self.findIndex((t) => t.city.id === value.city.id),
		);
		transports.forEach((transport) => {
			let nextCity;
			this.service.transports.forEach((value, index) => {
				if (value.city.id != transport.city.id) {
					return;
				}
				nextCity = this.service.transports[index + 1];
			});
			if (!nextCity) {
				return;
			}
			this.connect('city' + transport.city.id, 'city' + nextCity.city.id);
		});
	}

	generateConnections() {
		this.connections = [];
		if (!this.service.vehicleSelected) {
			return;
		}
		const transports = this.service.transports.filter((obj) => obj.vehicle.id == this.service.vehicleSelected.id);
		this.connections = [];
		for (let i = 0; i < transports.length - 1; i++) {
			this.connect('city' + transports[i].city.id, 'city' + transports[i + 1].city.id);
		}
	}

	private connect(div1, div2) {
		const off1 = this.getOffset(div1);
		const off2 = this.getOffset(div2);
		let x1 = 0;
		let x2 = 0;
		let y1 = 0;
		let y2 = 0;
		if (off1.left == off2.left) {
			x1 = off1.left + off1.width / 2;
			x2 = off2.left + off2.width / 2;
		} else if (off1.left > off2.left) {
			x1 = off1.left;
			x2 = off2.left + off2.width;
		} else {
			x1 = off1.left + off1.width;
			x2 = off2.left;
		}
		if (off1.top == off2.top) {
			y1 = off1.top + off1.height / 2;
			y2 = off2.top + off2.height / 2;
		} else if (off1.top > off2.top) {
			y1 = off1.top;
			y2 = off2.top + off2.height;
		} else {
			y1 = off1.top + off1.height;
			y2 = off2.top;
		}
		const length = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
		const cx = (x1 + x2) / 2 - length / 2;
		const cy = (y1 + y2) / 2 - 2;
		const angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI);
		this.connections.push({
			x: cx,
			y: cy,
			length: length,
			angle: angle,
			style: {
				left: cx + 'px',
				top: cy + 'px',
				width: length + 'px',
				transform: 'rotate(' + angle + 'deg)',
			},
		});
	}

	private getOffset(elementId) {
		const element = document.getElementById(elementId);
		const rect = element.getBoundingClientRect();
		return {
			left: Math.floor(rect.left + window.pageXOffset),
			top: Math.floor(rect.top + window.pageYOffset),
			width: rect.width || element.offsetWidth,
			height: rect.height || element.offsetHeight,
		};
	}

	private cityFindByPos(x, y) {
		const city = this.service.cities.find((objFind) => objFind.gridX == x && objFind.gridY == y);
		if (city) {
			// city.assigned = 0
			return city;
		}
		return {};
	}
}
